import { render, staticRenderFns } from "./VoiceMessage.vue?vue&type=template&id=556d22e4&scoped=true"
import script from "./VoiceMessage.vue?vue&type=script&lang=js"
export * from "./VoiceMessage.vue?vue&type=script&lang=js"
import style0 from "./VoiceMessage.vue?vue&type=style&index=0&id=556d22e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556d22e4",
  null
  
)

export default component.exports